import React from 'react';
import cn from 'classnames';

import { Main, InfoCard } from '@/components';
import { IProps } from '@/components/InfoCard/index';
import Iphone from './images/iphone.png';
import MacBook from './images/macBook.png';
import Auto from './images/auto.png';

import styles from './access.module.scss';

const Access: React.FC = () => {
  const cards: IProps[] = [
    {
      id: 1,
      title: 'Гибкая настройка',
      text: 'Настройка доступов для согласования и лимитов видимости',
      className: styles.container__card
    },
    {
      id: 2,
      title: 'Ценовые ограничения',
      text: 'Настройка ценовых ограничений для монопарков',
      className: styles.container__card
    },
    {
      id: 3,
      title: 'Online-запись',
      text: 'Запись на любую услугу в любом городе',
      type: 'info',
      className: styles.container__card_full,
      src: Iphone,
      imageClassName: styles.container__cardImage_online
    },
    {
      id: 4,
      title: 'Фото и видео',
      text: 'Просмотр состояния узлов и результатов диагностики автомобиля',
      type: 'info',
      className: cn(
        styles.container__card_full,
        styles.container__card_desktop
      ),
      src: Auto,
      imageClassName: styles.container__cardImage_photo
    },
    {
      id: 5,
      title: 'Дистанционное согласование',
      text: 'Согласование каждого ремонта online',
      className: styles.container__card
    },
    {
      id: 6,
      title: 'Отслеживание статуса СТО',
      text: 'Просмотр статуса ремонта и времени простоя авто на СТО',
      className: styles.container__card
    },
    {
      id: 7,
      title: 'Фото и видео',
      text: 'Просмотр состояния узлов и результатов диагностики автомобиля',
      type: 'info',
      className: cn(styles.container__card_full, styles.container__card_mobile),
      src: Auto,
      imageClassName: styles.container__cardImage_photo
    },
    {
      id: 8,
      title: 'Документирование',
      text: 'Получение полного пакета закрывающих документов в ЭДО',
      className: styles.container__card
    },
    {
      id: 9,
      title: 'Управление скидками',
      text: 'Настройка скидок и спецусловий в рамках контракта',
      className: styles.container__card
    },
    {
      id: 10,
      title: 'Получить доступ',
      type: 'link',
      className: styles.container__card_full,
      src: MacBook,
      imageClassName: styles.container__cardImage_link,
      href: 'https://novosibirsk.fitauto.ru/corp/fleet/?utm_source=lending&utm_medium=poluchit_dostup'
    }
  ];

  return (
    <div className={styles.container}>
      <Main>
        <h2 className={styles.container__title}>
          Получите{' '}
          <span className={styles.container__title_info}>бесплатный</span>{' '}
          доступ к системе{' '}
          <span className={styles.container__title_company}>FIT FLEET</span>
        </h2>
        <div className={styles.container__cards}>
          {cards.map((card) => (
            <InfoCard
              key={card.id}
              className={card.className}
              type={card.type}
              title={card.title}
              text={card.text}
              src={card.src}
              imageClassName={card.imageClassName}
              href={card.href}
            />
          ))}
        </div>
      </Main>
    </div>
  );
};

export default Access;
